import { render, staticRenderFns } from "./DocumentacaoNecessaria.vue?vue&type=template&id=5759b6c5&"
import script from "./DocumentacaoNecessaria.vue?vue&type=script&lang=js&"
export * from "./DocumentacaoNecessaria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DocumentacaoNecessaria.vue"
export default component.exports